import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { IConfigType } from "./@types";

const fetchClientConfigSideBar = async (): Promise<IConfigType> => {
  const config = await apiInputService.get("/clientConfig");
  const { data } = config;

  return data;
};

export const useGetClientConfigSideBar = (options?: any) => {
  const { subscription } = useSubscription();

  return useQuery<IConfigType>(
    ["client-config-sidebar", subscription],
    () => fetchClientConfigSideBar(),
    {
      ...options,
      enabled: !!subscription,
      staleTime: 0,
    },
  );
};
